exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".action-btns{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:.1fr;justify-items:center;width:100%}.action-btns>button{border-radius:100%;cursor:pointer;width:28px;height:28px}.action-btns__select{background-color:#52c883;border:1px solid #52c883}.action-btns__like{background-color:#56ccf2;border:1px solid #56ccf2}.action-btns__dislike{background-color:#73126c;border:1px solid #73126c}.action-btns__like svg{margin-top:-4px}.action-btns .disabled{background:gray;cursor:not-allowed}", ""]);

// exports
